<template>
  <div class="row col-12">
    <div class="row col-5" v-if="tipoMetodo == 'cadastro'">
      <q-tabs
        v-model="tab"
        style="padding: 0px; margin: 0px"
        dense
        class="q-mt-xl col-8 text-grey-7"
        active-color="black"
        no-caps
        active-bg-color="brand-11"
        indicator-color="transparent"
        align="justify"
      >
        <q-tab
          style="background-color: #d9d9d9; border-radius: 4px"
          name="esquerda"
          label="Mão Esquerda"
          class="col-12"
        />
        <q-tab
          style="background-color: #d9d9d9; border-radius: 4px"
          class="q-ml-sm q-mr-sm col-12"
          name="direita"
          label="Mão Direita"
        />
      </q-tabs>
    </div>
    <div class="row col-12">
      <div :class="{ row: !props.hiddenLeftContainer }" class="col-12">
        <div v-if="tipoMetodo == 'cadastro'" class="col-3 row justify-center">
          <div
            class="text-brand-1 row justify-center col-12 text-weight-bold q-mt-md"
          >
            Selecione o dedo que deseja cadastrar
          </div>
          <SelecaoDedo
            v-if="props.tipoMetodo == 'cadastro'"
            :indiceDedosCadastrados="indiceDedosCadastrados"
            :mao="tab"
            :tipoMetodo="tipoMetodo"
            :desabilitado="disable"
            :removerDedos="removerDedos"
            @enviarDedoSelecionado="receberDedoSelecionado"
          />
        </div>
        <q-separator
          v-if="tipoMetodo == 'cadastro'"
          class="q-mx-lg"
          size="2px"
          vertical
          inset
        />
        <div
          v-show="
            (dedoSelecionado != null && aplicacaoExecutando) ||
            (tipoMetodo == 'verificacao' && aplicacaoExecutando)
          "
          class="col-3"
        >
          <div class="text-brand-1 text-weight-bold q-mt-md row justify-center">
            Utilize o leitor biométrico
          </div>
          <div class="row justify-center q-mt-lg">
            <div
              class="row justify-center items-center"
              style="
                border: 1px solid #d9d9d9;
                height: 230px;
                width: 230px;
                border-radius: 8px;
              "
            >
              <q-icon
                v-if="!biometriaColetada"
                style="color: #d9d9d9"
                size="145px"
                name="fingerprint"
              />
              <q-icon
                v-if="
                  biometriaColetada &&
                  resultadoVerificacao &&
                  props.tipoMetodo == 'verificacao'
                "
                style="color: green"
                size="145px"
                name="sym_o_check"
              />
              <img
                v-show="biometriaColetada && props.tipoMetodo === 'cadastro'"
                src="../../assets//bioNO.png"
                id="biometria-negativa"
                style="width: 55%; height: 70%"
              />
            </div>
          </div>
          <div
            :style="
              !biometriaColetada
                ? 'font-size: 12px; color: #eebf00'
                : 'font-size: 12px; color: green'
            "
            class="text-weight-bold row q-mt-sm justify-center items-center"
          >
            {{
              !biometriaColetada ? "Coletando Biometria" : "Biometria Coletada"
            }}
            <q-circular-progress
              indeterminate
              rounded
              v-if="!biometriaColetada"
              size="14px"
              style="color: #eebf00"
              class="q-ml-sm"
            />
          </div>

          <div
            v-if="props.tipoMetodo == 'cadastro'"
            class="q-mt-md q-gutter-x-md q-mb-sm row col-12 justify-center"
          >
            <q-btn
              label="Salvar Biometria"
              style="
                background-color: #21324a;
                border-radius: 8px;
                color: white;
              "
              no-caps
              :disable="disable || !biometriaColetada"
              icon="save"
              @click="cadastrarBiometria"
            />
            <q-btn
              label="Cancelar"
              style="
                background-color: #304f78;
                border-radius: 8px;
                color: #304f78;
              "
              no-caps
              :disable="disable"
              outline
              icon="close"
              @click="cancelar()"
            />
          </div>
        </div>
        <div
          v-if="
            (dedoSelecionado != null && !aplicacaoExecutando) ||
            (!aplicacaoExecutando && tipoMetodo == 'verificacao')
          "
          class="col-4 text-brand-1 row items-center"
        >
          <div v-if="mensagemErro != null">
            <div class="row justify-center row col-12 q-mb-md">
              <q-icon size="50px" style="color: #eebf00" name="sym_o_info" />
            </div>
            <div class="row col-12 justify-center">
              <span
                style="text-align: center"
                class="q-mt-sm"
                v-html="mensagemErro"
              ></span>
            </div>
          </div>
        </div>
        <q-separator
          v-if="tipoMetodo == 'verificacao'"
          class="q-mx-lg"
          size="2px"
          vertical
          inset
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, defineEmits, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import SelecaoDedo from "./SelecaoDedo.vue";

const store = useStore();
const quasar = useQuasar();
const props = defineProps({
  tipoMetodo: {
    type: String,
    // cadastro ou verificacao
  },
  idUsuario: {},
  matriculaUsuario: {},
  atualizarDedosCadastrados: {
    type: Number,
  },
  hiddenLeftContainer: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits("atualizarBiometrias");

const indiceDedosCadastrados = ref([]);
const disable = ref(false);
const tab = ref("esquerda");
const dedoSelecionado = ref(null);
const aplicacaoExecutando = ref(false);
const versaoRegex = /^1\.(\d+)\.(\d+)$/;
const mensagemErro = ref(null);
const loading = ref(false);
const biometriaNegativa = ref("");
const biometriaColetada = ref(false);
const base64BiometriaImagens = ref([]);
const removerDedos = ref(0);
const resultadoVerificacao = ref(false);

const receberVersao = async () => {
  try {
    const response = await store.dispatch("biometria/getVersion");
    if (validarVersao(response.data.versao)) {
      aplicacaoExecutando.value = true;
      if (props.tipoMetodo === "verificacao") {
        coletarBiometria();
      }
      return;
    }
    mensagemErro.value =
      "Versão desatualizada, por favor faça o download da nova versão.";
  } catch (error) {
    mensagemErro.value =
      "Aplicação desktop parada, favor iniciar antes de começar as rotinas de cadastro/verificação. Se não tiver a aplicação instalada, <a target='blank' href='https://sites.google.com/multpex.com.br/basedeconhecimento/d%C3%BAvidas-administrativas/download-e-instala%C3%A7%C3%A3o-leitor-biom%C3%A9trico-web'>clique aqui </a> e acesse o nosso guia.";
  }
};

const receberDedosCadastrados = async () => {
  try {
    const response = await store.dispatch(
      "usuarioNovo/receberDedosCadastrados",
      {
        id: props.idUsuario,
      }
    );
    indiceDedosCadastrados.value = response.data;
    receberVersao();
  } catch (error) {
    console.log(error);
  }
};

const receberDedoSelecionado = (dedoObjetc) => {
  dedoSelecionado.value = dedoObjetc;
  if (aplicacaoExecutando.value) {
    coletarBiometria();
    return;
  }
};

const validarVersao = (version) => {
  return versaoRegex.test(version);
};

const coletarBiometria = async () => {
  disable.value = true;
  loading.value = true;
  try {
    let response = await store.dispatch("biometria/getIdentification");
    if (!response.data.sucesso) {
      quasar.notify({
        message: response.data.mensagemErro,
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      return;
    }

    let fingerPrint = response.data.imagemDigital;
    biometriaNegativa.value = response.data.imagemDigitalNegativa;
    if (fingerPrint) {
      let image = document.getElementById("biometria-negativa");
      biometriaColetada.value = true;
      image.src = "data:image/png;base64, " + biometriaNegativa.value;
      base64BiometriaImagens.value.push(fingerPrint);
    }
    disable.value = false;
    loading.value = false;
    if (props.tipoMetodo == "verificacao") {
      verificarBiometria();
      return;
    }
  } catch (error) {
    quasar.notify({
      message: error.response.data.mensagemErro,
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    disable.value = false;
    loading.value = false;
  }
};

const cancelar = () => {
  base64BiometriaImagens.value = [];
  biometriaColetada.value = false;
  removerDedos.value++;
  dedoSelecionado.value = null;
  let image = document.getElementById("biometria-negativa");
  image.src = "";
};

const cadastrarBiometria = async () => {
  disable.value = true;
  loading.value = true;
  try {
    await store.dispatch("usuarioNovo/cadastrarBiometria", {
      employeeId: parseInt(props.idUsuario),
      base64Image: base64BiometriaImagens.value,
      fingerPosition: dedoSelecionado.value.value,
      imageWidth: 320,
      imageHeight: 480,
      imageResolution: 500,
    });
    disable.value = false;
    loading.value = false;
    quasar.notify({
      message: "Biometria cadastrada com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    emits("atualizarBiometrias");
    cancelar();
  } catch (error) {
    console.log(error);
    disable.value = false;
    loading.value = false;
    quasar.notify({
      message: "Erro ao cadastrar biometria",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const verificarBiometria = async () => {
  disable.value = true;
  loading.value = true;
  try {
    const response = await store.dispatch("usuarioNovo/verificarBiometria", {
      userId: props.idUsuario,
      base64Image: base64BiometriaImagens.value[0],
      imageWidth: 320,
      imageHeight: 480,
      imageResolution: 500,
    });
    if (response.data == props.idUsuario) {
      quasar.notify({
        message: "Biometria verificada com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      resultadoVerificacao.value = true;
      emits("resultadoVerificacao", {
        resultadoVerificacao: resultadoVerificacao.value,
        biometriaNegativa: biometriaNegativa.value,
      });
      disable.value = false;
      loading.value = false;
      return;
    }
    quasar.notify({
      message:
        "A biometria verificada não coincide com a do solicitante, faça novamente o processo de verificação.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    resultadoVerificacao.value = false;
    emits("resultadoVerificacao", {
      resultadoVerificacao: resultadoVerificacao.value,
      biometriaNegativa: null,
    });
    disable.value = false;
    loading.value = false;
    cancelar();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao verificar biometria",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  () => props.atualizarDedosCadastrados,
  () => {
    receberDedosCadastrados();
  }
);

watch(
  () => dedoSelecionado.value,
  () => {
    biometriaColetada.value = false;
    loading.value = false;
    disable.value = false;
  }
);

onMounted(() => {
  receberDedosCadastrados();
});
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
